import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { PrimaryButton, ArrowLink } from "./Buttons";

export const SubpageHero = ({ eyebrow, title, body, onBuild, secondary, art, note, testId }) => (
  <section data-testid={testId} className="relative overflow-hidden pt-[120px] sm:pt-[150px]">
    <div aria-hidden="true" className="pointer-events-none absolute inset-0">
      <div className="absolute -left-32 top-10 h-80 w-80 rounded-full bg-lilac/[0.07] blur-3xl" />
      <div className="absolute -right-24 bottom-0 h-72 w-72 rounded-full bg-lilac-deep/[0.08] blur-3xl" />
    </div>

    <div
      className={`relative mx-auto w-full max-w-shell px-5 pb-16 sm:px-8 lg:pb-24 ${
        art ? "grid items-center gap-12 lg:grid-cols-2 lg:gap-8" : ""
      }`}
    >
      <Reveal className={art ? "" : "max-w-2xl"}>
        <Link
          to="/"
          data-testid={`${testId}-back-link`}
          className="mb-8 inline-flex items-center gap-2 rounded-sm text-xs font-bold uppercase tracking-[0.18em] text-paper/40 transition-colors duration-200 hover:text-paper focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lilac focus-visible:ring-offset-2 focus-visible:ring-offset-ink"
        >
          <ArrowLeft className="h-3.5 w-3.5" aria-hidden="true" />
          Back to home
        </Link>
        <Eyebrow testId={`${testId}-eyebrow`}>{eyebrow}</Eyebrow>
        <h1 className="mt-4 font-display text-4xl font-extrabold leading-[1.08] tracking-tight text-paper sm:text-5xl">
          {title}
        </h1>
        <p className="mt-5 max-w-md text-base text-paper/65 sm:text-lg">{body}</p>
        <div className="mt-8 flex flex-wrap items-center gap-x-8 gap-y-5">
          <PrimaryButton testId={`${testId}-build-button`} onClick={() => onBuild()}>
            Request a launch proposal
          </PrimaryButton>
          {secondary && (
            <ArrowLink testId={`${testId}-secondary-link`} target={secondary.target} className="!text-paper/80 hover:!text-paper">
              {secondary.label}
            </ArrowLink>
          )}
        </div>
        {note && <p className="mt-7 text-sm text-paper/40">{note}</p>}
      </Reveal>

      {art && (
        <Reveal delay={0.15} y={14}>
          {art}
        </Reveal>
      )}
    </div>
  </section>
);
